import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupCustomerManagementComponent } from './components/setup-customer-management/setup-customer-management.component';
import { CustomerManagementRoutingModule } from './customer-management-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { EditCustomerComponent } from './components/edit-customer/edit-customer.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { MoveSiteDialogComponent } from './components/move-site-dialog/move-site-dialog.component';
import { CommonModules } from '../../common/common.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    SetupCustomerManagementComponent,
    EditCustomerComponent,
    OnboardingComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CustomerManagementRoutingModule,
    CommonModules,
    ScrollingModule,
    MatAutocompleteModule,
    MoveSiteDialogComponent
  ],
})
export class CustomerManagementModule { }
